import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';


import content from './content';
import services from './services';
import slides from './slides';
import galleryImages from './galleryImages';

// import center from './center';
// import selectedHotel from './selectedHotel';
import selectedService from './selectedService';


const rootReducer = combineReducers({ services, selectedService, slides, galleryImages, content, routing: routerReducer });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js